import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Signin from 'src/app/login/views/Signin';
import Loader from 'src/shared/components/loader/Loader';
import PostAuthRedirect from './views/post-auth-redirect/PostAuthRedirect';

import TermsOfUseDeclined from './views/terms-of-use/TermsOfUseDeclined';
import ImpersonateUser from './views/impersonate-user/ImpersonateUser';

// Lazy load the terms of use component
const TermsOfUseComponent = lazy(() => import('./views/terms-of-use/TermsOfUse'));

const Login = () => {
    return (
        <Routes>
            <Route
                path={'/terms-of-use'}
                element={
                    <Suspense fallback={<Loader />}>
                        <TermsOfUseComponent />
                    </Suspense>
                }
            />
            <Route path={'/terms-of-use-declined'} element={<TermsOfUseDeclined />} />
            <Route path={'/impersonate-user'} element={<ImpersonateUser />} />
            <Route path={'/post-auth-redirect'} element={<PostAuthRedirect />} />
            <Route path={'/'} element={<Signin />} />
        </Routes>
    );
};
export default Login;
